import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
export { configure } from './api';
export const routes = [{
  path: '/event-gap',
  component: <History />
}, {
  path: '/event-gap/settlement',
  component: <SettlementQueue />
}, {
  path: '/event-gap/create',
  component: <PredictionInput />
}, {
  path: '/event-gap/prompts',
  component: <PublicPrompt />
}, {
  path: '/event-gap/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/event-gap/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'event-gap',
  label: 'Event Gaps',
  icon: 'ri-stock-line',
  link: '/event-gap'
};
export const publicNavigation = { label: 'Event Gaps', link: '/event-gap', group: 'AI modes' };
export function getNavigation({ admin, paid }) {
  return { ...navigation, subItems: [
    {id:'event-gap-history',label:'History',link:'/event-gap',parentId:navigation.id},
    ...(admin ? [
      {id:'event-gap-input',label:'Prediction Input',link:'/event-gap/create',parentId:navigation.id},
      {id:'event-gap-settlement',label:'Settlement',link:'/event-gap/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
